import React from 'react';
import { useNavigate } from 'react-router-dom';

const steps = [
  {
    number: '1',
    label: 'PASO 1:',
    title: 'DIAGNÓSTICO ESTRATÉGICO',
    icon: 'ri-search-line',
    paragraphs: [
      { prefix: '', text: '"Te escuchamos y diseccionamos tu operativa.' },
      {
        prefix: '',
        text: 'No te vendemos una IA genérica. Primero entendemos qué agente(s) encajan realmente en tu clínica y tu dolor.',
      },
      {
        prefix: 'El Resultado. ',
        text: 'Recibes propuesta arquitectónica sobre: quiénes son tus cuellos de botella (Mina, Félix o Custom) y qué procesos verás en alto rendimiento en semanas."',
      },
    ],
  },
  {
    number: '2',
    label: 'PASO 2:',
    title: 'ACTIVACIÓN & INGENIERÍA DE CONOCIMIENTO',
    icon: 'ri-brain-line',
    paragraphs: [
      { prefix: '', text: '"Creas tu Usuario y rellenas tu Contenido Privado. Aquí empieza la magia.' },
      {
        prefix: 'La Acción: ',
        text: 'Subes tu información al sistema. Si es un Agente a Medida, solo necesitamos tu documentación real (PEPS, webs, manuales). Sencillo.',
      },
      {
        prefix: 'El Proceso: ',
        text: 'Nuestro equipo convierte esos datos en conocimiento de IA de alto nivel, totalmente personalizado e irresistible a tu marca."',
      },
    ],
  },
  {
    number: '3',
    label: 'PASO 3:',
    title: 'INTEGRACIÓN SIN FRICCIÓN',
    icon: 'puzzle',
    paragraphs: [
      { prefix: '', text: '"Tu Agente no trabaja solo, caza con el grupo de tu empresa.' },
      {
        prefix: 'El Proceso. ',
        text: 'Integramos al ingeniero digital con tus sistemas ya existentes, tanto tu negocio en un plan completo de IA.',
      },
      {
        prefix: 'El Resultado: ',
        text: 'Tu información está a salvo. Si Mina gestiona citas, se conecta a tu CRM, Calendarios/Outlook, tu banco y tu booking y listo, diferente. Cero intrusismo, cero drama."',
      },
    ],
  },
  {
    number: '4',
    label: 'PASO 4:',
    title: 'CONTROL, MEDICIÓN & ESCALA',
    icon: 'ri-bar-chart-grouped-line',
    highlight: true,
    paragraphs: [
      { prefix: '', text: '"Dirige con tu Dashboard el rendimiento. Esto es mejora continua.' },
      { prefix: 'La Acción: ', text: 'Visualiza en tu Dashboard el rendimiento.' },
      {
        prefix: 'La Acción: ',
        text: 'Monitoriza las métricas, detecta el retorno obtenible, verifica conversiones y ajusta nuevas configuraciones o añade Agentes para sacar más valor. Que cada euro más invertido crezca en piloto automático."',
      },
    ],
  },
];

export const PurchaseSection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="precios"
      className="py-32 bg-gradient-to-b from-dark to-gray-900 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Timeline row */}
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-[60px] left-[12.5%] right-[12.5%] h-[3px]">
            <div className="w-full h-full bg-gradient-to-r from-primary/40 via-white/30 to-primary/40 relative">
              {/* Glow effect on line */}
              <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-white/20 to-primary/20 blur-sm"></div>
            </div>
          </div>
          {/* Bright center glow on line */}
          <div className="hidden lg:block absolute top-[52px] left-1/2 -translate-x-1/2 w-20 h-20 bg-white/20 rounded-full blur-xl"></div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 relative">
            {steps.map((step, index) => (
              <div key={step.number} className="flex flex-col items-center">
                {/* Icon circle */}
                <div className="relative mb-8">
                  {/* Outer glow ring */}
                  <div
                    className={`w-[120px] h-[120px] rounded-full flex items-center justify-center relative ${
                      step.highlight ? 'bg-gradient-to-br from-primary/30 to-primary/10' : ''
                    }`}
                  >
                    {/* Cyan ring border */}
                    <div className="absolute inset-0 rounded-full border-2 border-primary/60"></div>
                    {/* Subtle outer glow */}
                    <div className="absolute -inset-1 rounded-full border border-primary/20"></div>
                    {/* Inner dark circle */}
                    <div className="w-[100px] h-[100px] rounded-full bg-gray-900/90 border border-primary/30 flex items-center justify-center relative z-10 overflow-hidden">
                      {step.icon === 'puzzle' ? (
                        // Custom puzzle icon
                        <div className="relative w-14 h-14">
                          {/* Top-left piece */}
                          <div className="absolute top-0 left-0 w-7 h-7 bg-primary/80 rounded-tl-lg">
                            <div className="absolute -right-1.5 top-2 w-3 h-3 bg-primary/80 rounded-full"></div>
                            <div className="absolute left-2 -bottom-1.5 w-3 h-3 bg-primary/80 rounded-full"></div>
                          </div>
                          {/* Top-right piece */}
                          <div className="absolute top-0 right-0 w-7 h-7 bg-primary/70 rounded-tr-lg">
                            <div className="absolute -left-1.5 top-2 w-3 h-3 bg-gray-900/90 rounded-full"></div>
                            <div className="absolute right-2 -bottom-1.5 w-3 h-3 bg-primary/70 rounded-full"></div>
                          </div>
                          {/* Bottom-left piece */}
                          <div className="absolute bottom-0 left-0 w-7 h-7 bg-primary/60 rounded-bl-lg">
                            <div className="absolute -right-1.5 bottom-2 w-3 h-3 bg-primary/60 rounded-full"></div>
                            <div className="absolute left-2 -top-1.5 w-3 h-3 bg-gray-900/90 rounded-full"></div>
                          </div>
                          {/* Bottom-right piece */}
                          <div className="absolute bottom-0 right-0 w-7 h-7 bg-primary/50 rounded-br-lg">
                            <div className="absolute -left-1.5 bottom-2 w-3 h-3 bg-gray-900/90 rounded-full"></div>
                            <div className="absolute right-2 -top-1.5 w-3 h-3 bg-gray-900/90 rounded-full"></div>
                          </div>
                        </div>
                      ) : (
                        <i
                          className={`${step.icon} text-4xl ${
                            step.highlight ? 'text-primary' : 'text-primary/80'
                          }`}
                        ></i>
                      )}
                    </div>
                    {/* Glow effect for highlighted step */}
                    {step.highlight && (
                      <div className="absolute -inset-2 rounded-full bg-primary/10 blur-md -z-10"></div>
                    )}
                  </div>

                  {/* Lightning bolt between step 2 and 3 */}
                  {index === 1 && (
                    <div className="hidden lg:block absolute -right-[calc(50%+16px)] top-1/2 -translate-y-1/2">
                      <i className="ri-flashlight-fill text-primary/60 text-lg"></i>
                    </div>
                  )}
                </div>

                {/* Highlight badge for step 4 */}
                {step.highlight && (
                  <div className="text-center mb-4 -mt-2">
                    <p className="text-[22px] font-display font-bold text-white tracking-wide">
                      ¡YA ESTÁS DENTRO!
                    </p>
                    <p className="text-[14px] text-gray-400 mt-1 leading-relaxed italic max-w-[220px] mx-auto">
                      En este punto, el sistema entra en &quot;Go Live&quot;. Ese peso que te
                      quitaste de encima, ahora es visibilidad operando 24/7.
                    </p>
                  </div>
                )}

                {/* Step label and title */}
                <div className="text-center mb-5">
                  <h4 className="text-[15px] font-display font-bold text-white uppercase tracking-wider">
                    <a href="#precios" className="hover:text-primary transition-colors">
                      {step.label}
                      <br />
                      {step.title}
                    </a>
                  </h4>
                </div>

                {/* Description paragraphs */}
                <div className="text-left w-full space-y-3">
                  {step.paragraphs.map((p, pIdx) => (
                    <p key={pIdx} className="text-[14px] leading-relaxed text-gray-400">
                      {p.prefix && (
                        <span className="text-white font-semibold">{p.prefix}</span>
                      )}
                      {p.text}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        {/* Removed - Button deleted as requested */}
      </div>
    </section>
  );
};
